export enum BatteryStatus {
  HIGH = 'HIGH',
  LOW = 'LOW',
  CRITICAL = 'CRITICAL',
  UNKNOWN = 'UNKNOWN',
}
